/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateAccountSigningKey.defs.js'
export { main as default } from './updateAccountSigningKey.defs.js'
